import React, { useState } from 'react';
import { FolderOutlined, CloseOutlined, PlusOutlined } from '@ant-design/icons';
import {
  CommunityPanel,
  FolderAddButton,
  FolderCreateButton,
  FolderCreateRow,
  FolderDeleteButton,
  FolderFilterButton,
  FolderFilterButtonWrap,
  FolderFilterList,
  FolderInput,
  SidebarHeader,
  SidebarTitle,
} from './index.styled';
import { Folder } from './types';

type Props = {
  folders: Folder[];
  selectedFolderId: string;
  newFolderName: string;
  onNewFolderNameChange: (name: string) => void;
  onCreateFolder: () => Promise<void> | void;
  onSelectFolder: (id: string) => void;
  onDeleteFolder: (id: string) => void;
  title?: string;
  description?: string;
};

export default function FolderSidebar({
  folders,
  selectedFolderId,
  newFolderName,
  onNewFolderNameChange,
  onCreateFolder,
  onSelectFolder,
  onDeleteFolder,
  title = 'My Research Ideas',
}: Props) {
  const [isAddingFolder, setIsAddingFolder] = useState(false);

  const handleAddClick = () => {
    setIsAddingFolder(true);
  };

  const handleSaveFolder = async () => {
    if (!newFolderName.trim()) return;

    await onCreateFolder();
    setIsAddingFolder(false);
  };

  const handleCancel = () => {
    setIsAddingFolder(false);
    onNewFolderNameChange('');
  };

  return (
    <CommunityPanel>
      <SidebarHeader>
        <SidebarTitle>{title}</SidebarTitle>
        <FolderAddButton type="button" onClick={handleAddClick}>
          <PlusOutlined /> Add folder
        </FolderAddButton>

      </SidebarHeader>

      {isAddingFolder && (
        <FolderCreateRow>
          <FolderInput
            placeholder="Folder name"
            value={newFolderName}
            onChange={(e) => onNewFolderNameChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSaveFolder();
              }
              if (e.key === 'Escape') {
                handleCancel();
              }
            }}
          />
          <FolderCreateButton type="button" onClick={handleSaveFolder}>
            <PlusOutlined />
          </FolderCreateButton>
          <FolderCreateButton type="button" onClick={handleCancel}>
            <CloseOutlined />
          </FolderCreateButton>
        </FolderCreateRow>
      )}

      <FolderFilterList>
        <FolderFilterButtonWrap $active={selectedFolderId === 'all'}>
          <FolderFilterButton
            $active={selectedFolderId === 'all'}
            type="button"
            onClick={() => onSelectFolder('all')}
          >
            <FolderOutlined /> All folders
          </FolderFilterButton>
        </FolderFilterButtonWrap>
        {folders.map((folder) => (
          <FolderFilterButtonWrap key={folder.id} $active={selectedFolderId === folder.id}>
            <FolderFilterButton
              $active={selectedFolderId === folder.id}
              type="button"
              onClick={() => onSelectFolder(folder.id)}
            >
              <FolderOutlined /> {folder.name}
            </FolderFilterButton>
            <FolderDeleteButton type="button" onClick={() => onDeleteFolder(folder.id)}>
              <CloseOutlined />
            </FolderDeleteButton>
          </FolderFilterButtonWrap>
        ))}
      </FolderFilterList>
    </CommunityPanel>
  );
}
